import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MediaIndexSection from './components/MediaIndexSection';
import AppAboutSection from './components/AppAboutSection';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <MediaIndexSection />
        <AppAboutSection />
        <FAQSection />
        <CarouselSection />
        <RankingSection />
        <UpdatesSection />
        <TopicsSection />
        <CardsSection />
        <CommentsSection />
        <ContactSection />
        <FeaturesSection />
      </main>

      <Footer />
    </>
  );
}